var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("grid-container", { staticClass: "text-center" }, [
    _c("p", [_vm._v("Congratulations on completing your appraisal form!")]),
    _c("p", [_vm._v("You will be notified once the procedure is completed!")]),
    _c("p", [_vm._v("Thank you and we hope you enjoyed the experience!")]),
    _c(
      "div",
      { staticClass: "feedback-wrapper" },
      [
        !_vm.isEvaluator || _vm.isEvaluatorButCandidate
          ? _c(
              "el-form",
              { ref: "form", attrs: { size: "normal" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "" } },
                  [
                    _c("template", { slot: "label" }, [
                      _c("div", { staticStyle: { "text-align": "left" } }, [
                        _vm._v(
                          "\n            Comments and Feedback\n          "
                        )
                      ])
                    ]),
                    _c("el-input", {
                      attrs: { type: "textarea", rows: 5 },
                      model: {
                        value: _vm.textarea,
                        callback: function($$v) {
                          _vm.textarea = $$v
                        },
                        expression: "textarea"
                      }
                    })
                  ],
                  2
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          disabled: _vm.textarea == null || _vm.textarea == ""
                        },
                        on: { click: _vm.sendFeedback }
                      },
                      [_vm._v("Submit Feedback")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "secondary" },
                        on: { click: _vm.returnToDashboard }
                      },
                      [_vm._v("Return To Dashboard")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "secondary" },
                    on: { click: _vm.returnToDashboard }
                  },
                  [_vm._v("Return To Dashboard")]
                )
              ],
              1
            )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }